/**
 * Per-chain gmxinfra REST API host. GMX V2 is deployed on Arbitrum One and
 * Avalanche C-Chain; each has its own API host serving the same routes
 * (`/apy`, `/markets`, `/glvs`, `/tokens`).
 */
export const GMX_API_HOSTS: { [chainId: string]: string } = {
  '42161': 'https://arbitrum-api.gmxinfra.io',
  '43114': 'https://avalanche-api.gmxinfra.io',
}

/** Chains for which a GMX vault listing is available. */
export const GMX_SUPPORTED_CHAINS = Object.keys(GMX_API_HOSTS)

/** Resolve the gmxinfra API base for a chain, or `undefined` if unsupported. */
export const getGmxApiHost = (chainId: string): string | undefined =>
  GMX_API_HOSTS[chainId]
